import styled from "styled-components";
import { Modal as AntModal } from "antd";
import { SpinBonusBg } from "@assets";

export const Modal = styled(AntModal)`
	.ant-modal-content {
		border: none !important;
		background-image: url(${SpinBonusBg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		width: 365px !important;
		height: 423px !important;
		box-shadow: none !important;
		background-color: transparent !important;
	}
	@media screen and (max-width: 413px) {
		width: 265px !important;
		height: 323px !important;
		.ant-modal-content {
			width: 265px !important;
			height: 323px !important;
		}
	}
`;

export const AmountWrapper = styled.div`
	margin-top: 16px;

	color: #FFCE00;
	text-align: center;
	font-size: 30px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	@media screen and (max-width: 413px) {
		margin-top: 8px;
		font-size: 24px;
	}
`;

export const OkWrapper = styled.div`
	border-radius: 24px;
	background: #FFCE00;
	margin-top: 16px;
	cursor: pointer;
	padding: 13px 0;

	color: #000;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	@media screen and (max-width: 413px){
		margin-top: 8px;
		font-size: 14px;
		padding: 10px 0;
	}
`;

export const ModalTitle = styled.div`
	margin-top: 110px;
	color: #FFF;
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;

	@media screen and (max-width: 413px){
		margin-top: 65px;
		font-size: 16px;
	}
`

export const ModalLabel = styled.div`
	margin-top: 8px;
	color: rgba(255, 255, 255, 0.60);
	text-align: center;
	font-size: 15px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	@media screen and (max-width: 413px){
		font-size: 13px;
	}
`

export const ExpiredText = styled.div`
	margin: 8px 0 0 0;

	color: rgba(255, 255, 255, 0.60);
	text-align: center;
	font-size: 15px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	@media screen and (max-width: 413px) {
		font-size: 13px;
		margin-top: 5px;
	}
`;

